import { requestCreator, UnknownError } from "../../common/actions/VisitApi";

export const requestToFollowCompany = requestCreator<number, null, UnknownError>(companyId => ({
  path: `/api/v2/company_followings`,
  method: "POST",
  body: {
    company_id: companyId,
  },
}));

export const requestToUnfollowCompany = requestCreator<number, null, UnknownError>(companyId => ({
  path: `/api/v2/company_followings`,
  method: "DELETE",
  body: {
    company_id: companyId,
  },
}));



// WEBPACK FOOTER //
// ./frontend/src/company_followings/api/index.ts